module.exports = {
    fr: {
        meta: {
            title: "Blog de Davoyage : découvrez les dernières tendances en matière de transport privé",
            description: "Découvrez les dernières tendances en matière de transport privé sur le blog de Davoyage, votre partenaire de confiance pour vos déplacements professionnels ou personnels. Retrouvez des conseils, des astuces et des actualités sur notre blog pour voyager en toute sérénité.",    
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes Classe V Davoyage, chauffeur privé"
            }
        },
        eyebrow: "Carnets de route",
        head: "Escapades et transferts au départ de Lyon",
        lead: "Vignobles, stations de ski, aéroports\u00a0: itinéraires, temps de trajet et conseils de nos chauffeurs pour voyager sans prendre le volant.",
        photoBy: "Photo\u00a0:",
        photoOn: "sur",
        crumb: "Blog",
        all: "Tous",
        featured: "À la une",
        latest: "Derniers articles",
        related: "À lire ensuite",
        allArticles: "Tous les articles",
        fallback: "Nos articles sont pour l'instant disponibles en anglais.",
        readMore: "Lire l'article",
        readTime: "min de lecture",
        updated: "Mis à jour le",
        fromLyon: "depuis Lyon",
        author: "L'équipe Davoyage",
        facts: "En bref",
        toc: "Sommaire",
        quote: "Demander un devis",
        quoteShort: "Devis",
        call: "Appeler",
        bookEyebrow: "Réserver ce trajet",
        bookTitle: "Trajet avec chauffeur privé",
        bookPoints: ["Prise en charge à l'hôtel, à la gare ou à l'aéroport", "Votre chauffeur vous attend à chaque étape", "Vos bagages et achats restent dans le coffre"],
        ctaEyebrow: "Votre trajet",
        ctaTitle: "Une station, un vignoble, un vol à attraper\u00a0?",
        ctaText: "Dites-nous la date, le nombre de passagers et vos envies\u00a0: nous vous envoyons une proposition.",
        categories: {
            vignobles: "Vignobles",
            ski: "Stations de ski",
            aeroports: "Aéroports et gares",
            hotels: "Hôtels",
            excursions: "Excursions",
            pratique: "Infos pratiques"
        }
    },
    en: {
        meta: {
            title: "Davoyage Blog - Stay up-to-date with the latest travel tips and trends",
            description: "Stay informed with Davoyage Blog, your source for travel tips, trends, and news. From insider knowledge to destination guides, we've got you covered.",    
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes Classe V Davoyage, chauffeur privé"
            }
        },
        eyebrow: "Travel notes",
        head: "Day trips and transfers from Lyon",
        lead: "Vineyards, ski resorts, airports: routes, travel times and tips from our drivers, so you can travel without taking the wheel.",
        photoBy: "Photo:",
        photoOn: "on",
        crumb: "Blog",
        all: "All",
        featured: "Featured",
        latest: "Latest articles",
        related: "Read next",
        allArticles: "All articles",
        fallback: "Our articles are currently available in English.",
        readMore: "Read the article",
        readTime: "min read",
        updated: "Updated",
        fromLyon: "from Lyon",
        author: "The Davoyage team",
        facts: "At a glance",
        toc: "Contents",
        quote: "Get a quote",
        quoteShort: "Get a quote",
        call: "Call",
        bookEyebrow: "Book this trip",
        bookTitle: "Ride with a private driver",
        bookPoints: ["Pick-up at your hotel, station or airport", "Your driver waits for you at every stop", "Your luggage and purchases stay in the trunk"],
        ctaEyebrow: "Your trip",
        ctaTitle: "A ski resort, a vineyard, a flight to catch?",
        ctaText: "Tell us the date, how many you are and what you would like to see: we will send you a proposal.",
        categories: {
            vignobles: "Wine regions",
            ski: "Ski resorts",
            aeroports: "Airports and stations",
            hotels: "Hotels",
            excursions: "Day trips",
            pratique: "Practical info"
        }
    },
    ru: {
        meta: {
            title: "Блог Davoyage - Будьте в курсе последних советов и тенденций в путешествиях",
            description: "Будьте в курсе событий с блогом Davoyage, вашим источником советов, тенденций и новостей в сфере путешествий. От экспертной информации до путеводителей, мы следим за всеми новинками.",
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes Classe V Davoyage, chauffeur privé"
            }
        },
        eyebrow: "Путевые заметки",
        head: "Поездки и трансферы из Лиона",
        lead: "Виноградники, горнолыжные курорты, аэропорты: маршруты, время в пути и советы наших водителей, чтобы путешествовать, не садясь за руль.",
        photoBy: "Фото:",
        photoOn: "/",
        crumb: "Блог",
        all: "Все",
        featured: "Главное",
        latest: "Новые статьи",
        related: "Читайте также",
        allArticles: "Все статьи",
        fallback: "Наши статьи пока доступны на английском языке.",
        readMore: "Читать статью",
        readTime: "мин чтения",
        updated: "Обновлено",
        fromLyon: "от Лиона",
        author: "Команда Davoyage",
        facts: "Коротко",
        toc: "Содержание",
        quote: "Запросить стоимость",
        quoteShort: "Узнать цену",
        call: "Позвонить",
        bookEyebrow: "Забронировать поездку",
        bookTitle: "Поездка с частным водителем",
        bookPoints: ["Встреча у отеля, на вокзале или в аэропорту", "Водитель ждет вас на каждой остановке", "Багаж и покупки остаются в багажнике"],
        ctaEyebrow: "Ваша поездка",
        ctaTitle: "Курорт, виноградники или рейс, на который нужно успеть?",
        ctaText: "Сообщите дату, число пассажиров и ваши пожелания, и мы пришлем предложение.",
        categories: {
            vignobles: "Винные туры",
            ski: "Горнолыжные курорты",
            aeroports: "Аэропорты и вокзалы",
            hotels: "Отели",
            excursions: "Экскурсии",
            pratique: "Полезная информация"
        }
    },
    de: {
        meta: {
            title: "Davoyage-Blog: Ausflüge und Transfers ab Lyon",
            description: "Weinregionen, Skiorte, Flughäfen: Routen, Fahrzeiten und Tipps unserer Chauffeure für Ihre Reisen ab Lyon."
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes V-Klasse von Davoyage, Privatchauffeur"
            }
        },
        eyebrow: "Reisenotizen",
        head: "Ausflüge und Transfers ab Lyon",
        lead: "Weinregionen, Skiorte, Flughäfen: Routen, Fahrzeiten und Tipps unserer Chauffeure – damit Sie reisen, ohne selbst zu fahren.",
        photoBy: "Foto:",
        photoOn: "auf",
        crumb: "Blog",
        all: "Alle",
        featured: "Empfohlen",
        latest: "Neueste Artikel",
        related: "Weiterlesen",
        allArticles: "Alle Artikel",
        readMore: "Artikel lesen",
        readTime: "Min. Lesezeit",
        updated: "Aktualisiert am",
        fromLyon: "ab Lyon",
        author: "Das Davoyage-Team",
        facts: "Auf einen Blick",
        toc: "Inhalt",
        quote: "Angebot anfordern",
        quoteShort: "Angebot",
        call: "Anrufen",
        bookEyebrow: "Diese Fahrt buchen",
        bookTitle: "Mit Privatchauffeur reisen",
        bookPoints: [
            "Abholung an Ihrem Hotel, Bahnhof oder Flughafen",
            "Ihr Chauffeur wartet bei jedem Halt auf Sie",
            "Gepäck und Einkäufe bleiben im Kofferraum"
        ],
        ctaEyebrow: "Ihre Fahrt",
        ctaTitle: "Ein Skiort, ein Weingut, ein Flug?",
        ctaText: "Nennen Sie uns Datum, Personenzahl und Ihre Wünsche – wir senden Ihnen ein Angebot.",
        categories: {
            vignobles: "Weinregionen",
            ski: "Skiorte",
            aeroports: "Flughäfen und Bahnhöfe",
            hotels: "Hotels",
            excursions: "Ausflüge",
            pratique: "Praktische Infos"
        },
        fallback: "Unsere Artikel gibt es derzeit auf Englisch."
    },
    it: {
        meta: {
            title: "Blog Davoyage: gite e transfer da Lione",
            description: "Vigneti, stazioni sciistiche, aeroporti: itinerari, tempi di percorrenza e consigli dei nostri autisti per i tuoi viaggi da Lione."
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes Classe V Davoyage, autista privato"
            }
        },
        eyebrow: "Taccuino di viaggio",
        head: "Gite e transfer da Lione",
        lead: "Vigneti, stazioni sciistiche, aeroporti: itinerari, tempi di percorrenza e consigli dei nostri autisti, per viaggiare senza metterti al volante.",
        photoBy: "Foto:",
        photoOn: "su",
        crumb: "Blog",
        all: "Tutti",
        featured: "In evidenza",
        latest: "Ultimi articoli",
        related: "Da leggere anche",
        allArticles: "Tutti gli articoli",
        readMore: "Leggi l'articolo",
        readTime: "min di lettura",
        updated: "Aggiornato il",
        fromLyon: "da Lione",
        author: "Il team Davoyage",
        facts: "In breve",
        toc: "Indice",
        quote: "Richiedi un preventivo",
        quoteShort: "Preventivo",
        call: "Chiama",
        bookEyebrow: "Prenota questo viaggio",
        bookTitle: "Viaggia con un autista privato",
        bookPoints: [
            "Prelievo in hotel, in stazione o in aeroporto",
            "Il tuo autista ti aspetta a ogni tappa",
            "Bagagli e acquisti restano nel bagagliaio"
        ],
        ctaEyebrow: "Il tuo viaggio",
        ctaTitle: "Una stazione sciistica, un vigneto, un volo da prendere?",
        ctaText: "Indicaci la data, quanti siete e cosa vorresti vedere: ti invieremo una proposta.",
        categories: {
            vignobles: "Vigneti",
            ski: "Stazioni sciistiche",
            aeroports: "Aeroporti e stazioni",
            hotels: "Hotel",
            excursions: "Gite",
            pratique: "Informazioni pratiche"
        },
        fallback: "I nostri articoli sono al momento disponibili in inglese."
    },
    es: {
        meta: {
            title: "Blog de Davoyage: excursiones y traslados desde Lyon",
            description: "Viñedos, estaciones de esquí, aeropuertos: rutas, tiempos de trayecto y consejos de nuestros chóferes para sus viajes desde Lyon."
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes Clase V de Davoyage, chófer privado"
            }
        },
        eyebrow: "Cuaderno de viaje",
        head: "Excursiones y traslados desde Lyon",
        lead: "Viñedos, estaciones de esquí, aeropuertos: rutas, tiempos de trayecto y consejos de nuestros chóferes, para viajar sin ponerse al volante.",
        photoBy: "Foto:",
        photoOn: "en",
        crumb: "Blog",
        all: "Todos",
        featured: "Destacado",
        latest: "Últimos artículos",
        related: "Para seguir leyendo",
        allArticles: "Todos los artículos",
        fallback: "Por ahora, nuestros artículos están disponibles en inglés.",
        readMore: "Leer el artículo",
        readTime: "min de lectura",
        updated: "Actualizado el",
        fromLyon: "desde Lyon",
        author: "El equipo de Davoyage",
        facts: "En resumen",
        toc: "Índice",
        quote: "Solicitar un presupuesto",
        quoteShort: "Presupuesto",
        call: "Llamar",
        bookEyebrow: "Reserve este trayecto",
        bookTitle: "Viaje con chófer privado",
        bookPoints: [
            "Recogida en su hotel, estación o aeropuerto",
            "Su chófer le espera en cada parada",
            "Su equipaje y sus compras se quedan en el maletero"
        ],
        ctaEyebrow: "Su viaje",
        ctaTitle: "¿Una estación de esquí, un viñedo, un vuelo que tomar?",
        ctaText: "Indíquenos la fecha, cuántos son y qué les gustaría ver: le enviaremos una propuesta.",
        categories: {
            vignobles: "Viñedos",
            ski: "Estaciones de esquí",
            aeroports: "Aeropuertos y estaciones",
            hotels: "Hoteles",
            excursions: "Excursiones",
            pratique: "Información práctica"
        }
    }
};